import { createApi, BaseQueryFn  } from '@reduxjs/toolkit/query/react'
import getConfig from "../app/config";
import axios, { AxiosRequestConfig, AxiosError } from 'axios'
import { useState } from 'react';

const axiosBaseQuery =
  (
    { baseUrl }: { baseUrl: string } = { baseUrl: '' }
  ): BaseQueryFn<
    {
      url: string
      method: AxiosRequestConfig['method']
      data?: AxiosRequestConfig['data'],
      onUploadProgress?: AxiosRequestConfig['onUploadProgress']
    },
    unknown,
    unknown
  > =>
  async ({ url, method, data, onUploadProgress }) => {
    try {
      const result = await axios({ url: baseUrl + url, method, data, onUploadProgress })
      return { data: result.data }
    } catch (axiosError) {
      let err = axiosError as AxiosError
      return {
        error: { status: err.response?.status, data: err.response?.data },
      }
    }
  }
/*
  const fileUploadProgress = (progressEvent: any) => {
    const { loaded, total } = progressEvent

    const percentageProgress = Math.floor((loaded / total) * 100)
    console.log(percentageProgress);    
  };
*/
// Define a service using a base URL and expected endpoints
export const uploadApi = createApi({
  reducerPath: 'uploadApi',
  baseQuery: axiosBaseQuery({ 
    baseUrl: getConfig().apiUrl }),  
  endpoints: (builder) => ({
    imagesUpload: builder.mutation<any, FormData>({
      query: (formData: FormData) => ({ url: 'image/Upload', method: 'post',  data: formData }),
    }) 
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useImagesUploadMutation } = uploadApi;